import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { UpsertCrossReferenceInput, UpsertCrossReferencePayload } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPSERT_CROSSREFERENCE = gql`
    mutation upsertCrossReference($input: UpsertCrossReferenceInput!){
        upsertCrossReference(input: $input){
            message
            errors {
                code
                message
            }
            result
            crossReference {
                id
            }
        }
    }
`;

export const mutationUpsertCrossReference = async (
    client: ApolloClient<NormalizedCacheObject>,
    args: {
        crossReferenceInput: UpsertCrossReferenceInput
    }
): Promise<UpsertCrossReferencePayload | undefined> => {
    const {
        code,
        description,
        id,
        val,
        version
    } = args.crossReferenceInput;
    const { data, errors} = await client.mutate<{ upsertCrossReference: UpsertCrossReferencePayload}>({
        variables: {
            input: {
                code,
                description,
                id,
                val,
                version
            }
        },
        mutation: MUTATION_UPSERT_CROSSREFERENCE
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred during the upsert CrossReference save.');
    }
    if (data && data.upsertCrossReference) {
        return data.upsertCrossReference;
    }
    return undefined;
}